import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  width: 100%;
  border: 1px solid #001871;
  background-color: #001871;
  color: white;
  padding: 0.8rem 0rem;
  border-radius: 20px;
  font-weight: 500;
  font-size: 1.5rem;
  outline: none;
  &:hover {
    background-color: #001871;
  }
  &:disabled {
    background-color: #143ed4;
    border: 1px solid #143ed4;
    color: #dadada;
  }
`;

const FooterButton = (props: FotterButtonProps) => {
  const { label, classNameContainer, className, ...rest } = props;
  return (
    <div className={` bg-white ${classNameContainer || 'footer_container__continuar'}`}>
      <div className="row justify-content-center py-3">
        <div className="col-11 col-sm-10 col-md-6 col-lg-4">
          {/*@ts-ignore */}
          <Button className={`${className || 'footer_button__continuar'}`} {...rest}>
            {label}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FooterButton;

export type FotterButtonProps = {
  label: string;
  stylePath?: string;
  classNameContainer?: string;
  className?: string;
} & React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;
